import React from "react";
import './stripes_component.scss';
import TemplateComponent from "../../containers/template_page/template_component/template_component";
import 'react-dropdown/style.css';
import hexToRgb from "../../utils/utils";
import {isMobileOnly} from "react-device-detect";
import axios from "axios";

class StripesComponent extends TemplateComponent {
    uuid = '';

    constructor(props) {
        super(props);
    };
    
    getSlides = ep => {
        axios.get(ep, {}).then(res => {
            this.setState({
                arrayData: res.data
            });
        });
    }

    componentDidMount() {
        this.getSlides(this.props.data.filter((e) => e.type.includes('uniqueness')).map((u) => u.data));
    }

    componentRender(data) {

          const boxStyle = (colors, opacity, img) =>  [
            {   
                backgroundImage: 'linear-gradient(rgba(' + colors + ', ' + opacity + '), rgba(' + colors + ', ' + opacity + ')), url(' + img + ')'
            }
          ]

        return (
            <div className="stripes-container d-flex">
                {this.state.arrayData?.sliders.map((el, i) => (
                    <p key={`${el.id}`} style={boxStyle(hexToRgb(el.color_code), 1, '')[0]}></p>
                ))}
        </div>
        )
    }
}

export default StripesComponent;
